import { render, staticRenderFns } from "./wideCard.vue?vue&type=template&id=2f5053e2&"
import script from "./wideCard.vue?vue&type=script&lang=js&"
export * from "./wideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports